
<template>
<div class="success" name="success">
  <topNav :title="title"></topNav>
  <div class="payContent">
    <h1>建设银行无感支付签约步骤</h1>
    <div class="one">
      <h3>1.下载“中国建设银行”手机APP至您的手机中</h3>
      <p><span>安卓手机点击链接：</span><a href="https://shouji.baidu.com/software/24846218.html">https://shouji.baidu.com/software/24846218.html</a>下载</p>
      <p><span>苹果手机点击链接：</span><a href="https://itunes.apple.com/cn/app/id391965015?mt=8">https://itunes.apple.com/cn/app/id391965015?mt=8</a>进入官方AppStore中下载</p>
       <a class="btn" href="wx2654d9155d70a468://" @click="getCCB()">在app内部打开</a>
    </div>
    <div class="procedure">
      <h3>2.打开建设银行APP开通龙支付功能。</h3>
      <img src="../../../static/images/qianyue1.png" alt="">
    </div>
      <div class="procedure">
      <h3>3.开通龙支付后，进入龙支付，点击“无感支付”图标</h3>
      <img src="../../../static/images/qianyue2.png" alt="">
    </div>
      <div class="procedure">
      <h3>4.进入无感支付绑定您的车牌号</h3>
      <img src="../../../static/images/qianyue3.png" alt="">
    </div>
      <div class="procedure">
      <h3>5.确认签约无感支付</h3>
      <img src="../../../static/images/qianyue4.png" alt="">
    </div>
      <div class="procedure">
      <h3>6.绑定成功，流程结束</h3>
      <img src="../../../static/images/qianyue5.png" alt="">
    </div>
  </div>
</div>
</template>
<script>
import topNav from "../topnav/topnav"
export default {
  name: 'paydetail',
  components:{
     topNav,
  },
  methods:{

    getCCB(){
        return function(){

        var clickedAt = +new Date;

         setTimeout(function(){

             !window.document.webkitHidden && setTimeout(function(){

                   if (+new Date - clickedAt < 2000){

                       window.location = 'https://shouji.baidu.com/software/24846218.html';

                   }

             }, 500);

         }, 500)

    };

}

  },
  data() {
    return {
      title:"建行绑定流程",
      href:""
    }
  },

}
</script>
<style>
.procedure h3{
  text-align: left;
  padding-left: 3%;
  font-size: 15px;
}
.procedure img{
  width: 95%;
}
h1{
  font-size: 24px;
  font-weight: 600;
  padding: 20px 0;
}
.one{
    text-align: left;
    /* padding-left: 3%; */
    margin: 0 13px 20px 13px;
}
.one a{
     word-break: break-all;
     color:#6d6aec;
}
.one h3{
  padding-bottom: 13px;
}
.one p{
  padding-bottom: 10px;
  padding-left: 3%;
  line-height: 18px;
}


</style>




// WEBPACK FOOTER //
// src/components/nofeel/CCBprocedure.vue